import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";

export interface WorkflowDataInterface {
    id: number;
    name: string;
    description: string;
    workflowType: string;
    mappingId?: number;
    revisionId?: number;
    dagSource?: {
        [key: string]: any
    };
    mappingData?: any;
    version?: number;
    status: boolean;
}

@Injectable()
export class WorkflowObservableService {
    constructor() { }

    private _workflowData$: Subject<WorkflowDataInterface> = new Subject();
    get workflowData$(): Observable<any> {
        return this._workflowData$.asObservable();
    }
    setWorkflowData(data: WorkflowDataInterface) {
        this._workflowData$.next(data);
    }
}
